import type { IManager } from '@/interfaces/hrManager';
import { apiService } from '../api.service';

import type { IPermissionType } from '@/interfaces/permissionTypes';
import type { LoginParamsInterface, UserResponseInterface, ShowParamsInterface, EditAccountParamsInterface,
              RecoverPasswordParamsInterface, ResetPasswordParamsInterface, ValidateTokenParamsInterface, 
              TwoFactorAuthResponseInterface, ResendTokenResponseInterface, SessionCheckResponseInterface } from '@/interfaces/users';

const UsersResource = {
  login: (params: LoginParamsInterface) => apiService.post<UserResponseInterface>('/v1/hr_manager/sign_in', params),
  loginV2: (params: LoginParamsInterface) => apiService.post<TwoFactorAuthResponseInterface>('/v2/hr_manager/sign_in', params),
  validateToken: (params: ValidateTokenParamsInterface) => apiService.postWithoutErrorHandling<UserResponseInterface>('/v2/sessions/hr_managers/validate_token', params),
  resendToken: () => apiService.get<ResendTokenResponseInterface>('/v2/sessions/hr_managers/resend_token'),
  checkSession: () => apiService.getWithoutErrorHandling<SessionCheckResponseInterface>('/v2/sessions/hr_managers/check'),
  signOut: () => apiService.deleteWithoutErrorHandling('/v1/hr_managers/sign_out'),
  show: (params?: ShowParamsInterface) => apiService.get<IManager>('v1/hr_managers/me', params),
  showSilent: (params?: ShowParamsInterface) => apiService.getWithoutErrorHandling<IManager>('v1/hr_managers/me', params),
  fetchPermissions: () => apiService.get<IPermissionType[]>('v1/hr_managers/me/permissions'),
  update: (params: EditAccountParamsInterface) => apiService.put<UserResponseInterface>('v1/hr_managers/me', params),
  recoverPassword: (params: RecoverPasswordParamsInterface) => apiService.post('v1/hr_managers/recover_password', params),
  resetPassWord: (params: ResetPasswordParamsInterface) => apiService.post('v1/hr_managers/reset_password', params),
};

export default UsersResource;
